var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 260,
    viewBox: "0 0 457 260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.55 22.15c-3.6 15.61 33.23 17.62 48.4 17.79 4.2.04 8.39-.35 12.51-1.2 12.83-2.6 40.91-9.43 36.98-18.72-5.09-11.98-20.35-3.63-20.35-3.63S80 7.34 54.03 1.37C28.05-4.61 28.16 15.3 28.16 15.3S5.06 2.53.55 22.15",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.96 34.1H2.86s-5.65-7.14 0-11.95c3.1-2.65 6.79-2.37 9.46-1.6 1.74.51 3.48-.66 3.86-2.43.63-2.94 2.58-6.78 8.19-9.05 5.51-2.24 9 1.17 11.02 4.68.66 1.15 2.43.98 2.83-.3C39.97 7.94 46.06.6 66.07.6c25.45 0 22.62 13.53 20.35 19.16a1.3 1.3 0 001.47 1.77c3.93-.84 11.21-1.93 14.48.63 4.6 3.6 4.6 11.95 4.6 11.95",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M1.57 4.78L.17.5l19.91 2.55L1.57 4.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M16.4.6L.36 5.65l2.4 6.18L16.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.26 9.1l12.98-7.17L19.87.61l5 .73L.27 9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M29.9 2.97L26.44.15.42 7.22l22.4-.67 7.08-3.58"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.98 19.62)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.55 22.15c-3.6 15.61 33.23 17.62 48.4 17.79 4.2.04 8.39-.35 12.51-1.2 12.83-2.6 40.91-9.43 36.98-18.72-5.09-11.98-20.35-3.63-20.35-3.63S80 7.34 54.03 1.37C28.05-4.61 28.16 15.3 28.16 15.3S5.06 2.53.55 22.15",
    fill: "#BFE2DF",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.42)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.96 34.1H2.86s-5.65-7.14 0-11.95c3.1-2.65 6.79-2.37 9.46-1.6 1.74.51 3.48-.66 3.86-2.43.63-2.94 2.58-6.78 8.19-9.05 5.51-2.24 9 1.17 11.02 4.68.66 1.15 2.43.98 2.83-.3C39.97 7.94 46.06.6 66.07.6c25.45 0 22.62 13.53 20.35 19.16a1.3 1.3 0 001.47 1.77c3.93-.84 11.21-1.93 14.48.63 4.6 3.6 4.6 11.95 4.6 11.95",
    fill: "#BFE2DF",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.43 94.93S82.94 51.18 50.01 47.36c-23.34 32.32 8.75 63.83 8.75 63.83l38.22 15.37 3.45-31.63",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9 65.67l-9.19 18.76-21.92-36.96c-.26-.04-.52-.08-.78-.1-.1.12-.18.25-.27.37l11.75 19.8-19.08-3.6-.1.54-.1.48 19.98 3.77 19.57 32.99-33.68-5.25.64 1.15 33.72 5.25 13.9 23.43.64.26.12-1.02L73.34 85.5l9.3-19-.74-.83",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.47 114.63S56.43 93.3 35.05 108.8c3.92 53.8 72.62 52.6 72.62 52.6l-18.2-46.78",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05 108.81l.05.62 46.84 25.34-26.7 11.31 1 .71 26.87-11.38 18.3 9.9-.59-1.5-35.62-19.27-6.4-21.1-1.12-.1 6.22 20.5-28.37-15.36-.48.33",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.97 78.08l2.07-4.6c.15.07.32.12.5.14.7.07 1.44-.5 1.57-1.2.3-.12.5-.42.64-.7l2.88 1.9s-2.19 5.11-4.47 6.62c-2.27 1.5-9.52 5.54-9.52 5.54l-1.15-.66 7.48-7.04",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1 85.28c-.09.1-.41.4-1.29.6-.78.2-2.53.13-2.08.86.83.29 1.76.73 1.76.73.52.12 1.35-.23 1.82-.54l1.33-1.15v-.9l-.36-.07c-.37.22-.77.37-1.18.47",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.88 85.67l-.07.11a4 4 0 01.33.1l1.25-.16a19.5 19.5 0 01-.15-.59l-2.8-.2s-.18.31.36.54c.55.23 1.08.2 1.08.2M339.38 201.35s-4.66 3.84-7.58 5.56c-2.39 1.4-7.23 2.38-8.94 2.7-.38.06-.78-.02-1.11-.23l-1.47-.97s-1.63-.13-1.92.9c.28.66.59 1.16.85 1.51.31.42.8.66 1.33.65 2.11-.05 8.22-.3 12.43-1.6 5.17-1.59 10.61-5.25 10.61-5.25l-4.2-3.27M338.75 198.82l1.05 2.83 2.95-1.3-2.63-3.9-1.37 2.37",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1 199.75c-.34.15-.67.25-.9.2-1.66-.93-2.42-5.28-2.42-5.28l1.23-1.4 2.57.25 1.36 2.5a2.3 2.3 0 01-.02 2.18 4.48 4.48 0 01-1.82 1.55",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.98 195.12c-.32-.38-.75-1.4-1.15-1.1-.3.2-1.36.78-1.73.96-.87.43-2.6.85-3.25-.48-.32-.66.04-1.55.37-1.92.31-.37.77-.58 1.25-.64 1.13-.13 2.77-.02 3.23-.37.77-.6 1.87-.5 2.21.22.37.79.54 2.16.52 3.08a4.57 4.57 0 01-.31 1.57l-1.14-1.32",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.9 194.78c-.27-.08-.62.14-.77.47-.15.34-.05.67.23.75.28.08.63-.13.78-.47.15-.34.05-.67-.23-.75",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52 253.28s-.01 1.76-3.53 2.81c-.72.22-.49.43-.63.73h4.06l1.58-1.78.5.42 1.14-1.12s-.53-1.63-1.4-1.64l-1.72.58",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.86 251.77l.66 1.51c.6.18 1.24-.02 1.64-.5l.07-.08-.53-1.56-1.84.63",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52 198.87c7.85-.87 15.06 13.82 15.06 13.82l-9.5 6.66s-10.23-9.38-8.57-17.67a3.51 3.51 0 013.01-2.81",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.18 254.14s-1.13 1.05-3.7 1.7c-.57.15-1.18-.04-1.18.9h3.12l2.6-.45v.44h1.4s.4-2.3-.42-2.59h-1.82",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.46 252.5l-.28 1.64c.51.36 1.19.38 1.72.06l.1-.06-.14-1.64h-1.4",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.09 219.35s-5.2 9.44-4.52 14.43c.69 5 9.72 18.88 9.72 18.88l1.64-.75s-1.82-10.51-3.52-15.36c-.4-1.15-.63-2.34-.1-3.43 2.36-4.87 5.33-12.88 5.33-12.88l-4.8-3.53-3.75 2.64",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32 217.78l8.85 35.57h1.92s1.48-10.22-.21-17.3a9.95 9.95 0 01-.2-3.23c.95-10.33.35-16.65-3.1-20.13l-7.26 5.09",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M74.65 99.28l-4.04 10.57-2.55-1.9 5.7-9.6.9.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.15 96.08c-.25.32-.38.71-.36 1.12l-.18 1.52.2.24.72.64c-.02-.32-.06 0-.06 0l1.15-2s1.4-.9-.36-2.22c-.17-.12-.4-.15-.58-.03-.43.29-.53.73-.53.73",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.73 117.48a66.4 66.4 0 004.88-7.63l-2.2-2.5-2.68 3.14v7",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85 257.25H91.74a2.65 2.65 0 01-2.64-2.64V188.5a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.64v66.1a2.65 2.65 0 01-2.64 2.65",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07 186.14h-66.11a2.65 2.65 0 01-2.64-2.64v-66.1a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.63v66.11a2.65 2.65 0 01-2.64 2.64",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.14 248.02c-2.12-18.3-6.86-30.45-17.92-30.45-10.73 0-15.59 12.15-17.81 30.45h35.73",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6 208.6c0 5.94 3.95 10.76 8.82 10.76 4.88 0 8.83-4.82 8.83-10.76 0-5.95-3.95-10.76-8.83-10.76-4.87 0-8.82 4.81-8.82 10.76",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4 212.35c3.13-6.26 1.83-12.54.47-14.1a10.58 10.58 0 00-8.25-3.67c-3.32 0-6.4 1.3-7.94 3.57-.51.75-3.85 5.13-.5 14.23-.24-4.59.36-11.26 2.17-9.8 8.6 6.95 11.9 5.68 13.06 6.6 1.57 1.23.27 3.49 1 3.17M132.13 219c3.1 2.3 8.15 6.02 9.17 10.07 2.92 11.58-9.23 10.7-9.23 10.7s6.26-2.49.48-14.44c-.23-.47-7.8-11.83-.42-6.33",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73 114.95H75.62a2.65 2.65 0 01-2.64-2.63V46.2a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.64 2.64v66.1a2.65 2.65 0 01-2.63 2.64",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13 66.67c1.5 2.82-.39 6.15-1.49 9.15-1.85 5.05-1.77 12.91 1.37 17.68a14.32 14.32 0 003.71 3.89 7.29 7.29 0 0011.34-4.82c1.2-7.12-5.58-10.38-9.62-30.23-3.6-9.02-6.25-6.23-7.76-5.88-3.52.82.52 6.53 2.45 10.2M102.67 66.67c-1.49 2.82.4 6.15 1.5 9.15 1.84 5.05 1.77 12.91-1.37 17.68a14.32 14.32 0 01-3.72 3.89 7.29 7.29 0 01-11.34-4.82c-1.19-7.12 5.59-10.38 9.62-30.23 3.6-9.02 6.26-6.23 7.76-5.88 3.52.82-.51 6.53-2.45 10.2",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 106.64c-2.1-18.3-6.85-30.45-17.92-30.45-10.73 0-15.58 12.15-17.8 30.45h35.72",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.27 67.22c0 5.94 3.95 10.76 8.82 10.76s8.82-4.82 8.82-10.76c0-5.94-3.95-10.76-8.82-10.76s-8.82 4.82-8.82 10.76",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6 70.98c3.12-6.26 1.3-12.54-.06-14.1a10.58 10.58 0 00-8.26-3.68c-3.31 0-6.39 1.3-7.93 3.57-.51.75-4.38 5.66-1.03 14.76-.24-4.6.89-10.75 2.7-9.3 8.6 6.96 15.02 4.13 16.18 5.05 1.56 1.23-2.33 4.01-1.6 3.7",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2 257.25h-66.1a2.65 2.65 0 01-2.65-2.64V188.5a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.64v66.1a2.65 2.65 0 01-2.64 2.65",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.16 247.95c-2.28-18.37-7.27-30.48-18.56-30.48-10.94 0-16.03 12.1-18.43 30.48h36.99",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6 208.1c0 6.2 4.13 11.23 9.22 11.23 5.09 0 9.21-5.03 9.21-11.24 0-6.2-4.12-11.23-9.21-11.23-5.09 0-9.21 5.03-9.21 11.23",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.72 211.67c1.45-5.83 1.64-7.32 1.64-7.32s-.3-4.36-.58-5c-.28-.62-5.97-4.77-9.62-4.77-3.65 0-8.45 3.46-9.08 4.28-.63.81-1.06 3.94-1.06 3.94s-.5 3.55 1.21 8.87c-.26-5.27-.49-9.89 1.86-8.86 10.99 4.82 12.63-1.32 14 .43 3.19 4.06.84 8.79 1.63 8.43",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46 186.14h-66.1a2.65 2.65 0 01-2.65-2.64v-66.1a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.63v66.11a2.65 2.65 0 01-2.64 2.64",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63 176.89c-2.28-18.38-7.27-30.49-18.56-30.49-10.95 0-16.04 12.11-18.43 30.49h36.99",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08 137.03c0 6.2 4.12 11.23 9.2 11.23 5.1 0 9.22-5.03 9.22-11.23s-4.12-11.24-9.21-11.24c-5.09 0-9.21 5.03-9.21 11.24",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19 140.6c1.45-5.82 1.64-7.31 1.64-7.31s-.3-4.37-.58-5c-.28-.63-5.97-4.78-9.62-4.78-3.65 0-8.45 3.47-9.08 4.28-.63.82-1.06 3.94-1.06 3.94s-.5 3.55 1.21 8.87c-.26-5.27-.5-9.89 1.86-8.86 10.99 4.82 12.63-1.31 14 .43 3.18 4.06.84 8.8 1.63 8.43",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3 257.25h-66.11a2.65 2.65 0 01-2.64-2.64V188.5a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.64v66.1a2.65 2.65 0 01-2.64 2.65",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.81 247.94c-2.5-17.9-7.73-29.54-19.02-29.54-10.96 0-16.28 11.65-18.88 29.54h37.9",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42 208.64c0 6.46 4.3 11.7 9.6 11.7 5.29 0 9.58-5.24 9.58-11.7 0-6.45-4.3-11.69-9.59-11.69-5.3 0-9.59 5.24-9.59 11.7",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27 212.36c1.51-6.06 1.71-7.6 1.71-7.6s.02-10.18-10.61-10.18c-10.07 0-10.55 8.55-10.55 8.55s-.52 3.7 1.26 9.23c-.28-5.48.71-11.59 1.93-9.22 2.82 5.5 13.14-1.37 14.57.45 3.31 4.23.87 9.15 1.7 8.77",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6 176.88c-2.5-17.9-7.73-29.54-19.03-29.54-10.95 0-16.27 11.65-18.88 29.54h37.9",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.21 137.58c0 6.46 4.3 11.7 9.59 11.7 5.3 0 9.59-5.24 9.59-11.7 0-6.46-4.3-11.69-9.59-11.69-5.3 0-9.59 5.23-9.59 11.7",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.58 139.22c1.5-6.06 1.19-5.53 1.19-5.53s.02-10.17-10.62-10.17c-10.06 0-10.55 8.55-10.55 8.55s-1.03 1.62.74 7.15c-.27-5.48.1-5.9 2.46-7.14 7.35-3.85 13.14-1.37 14.57.45 3.31 4.23 1.39 7.07 2.21 6.7",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.29 172.58h-66.11a2.65 2.65 0 01-2.64-2.64v-66.1a2.65 2.65 0 012.64-2.65h66.1a2.65 2.65 0 012.65 2.64v66.11a2.65 2.65 0 01-2.64 2.64",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.04 163.6c-2.1-18.3-6.85-30.44-17.92-30.44-10.73 0-15.58 12.15-17.8 30.45h35.72",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51 124.18c0 5.95 3.95 10.76 8.82 10.76s8.82-4.81 8.82-10.76c0-5.94-3.95-10.75-8.82-10.75s-8.82 4.81-8.82 10.75",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.31 127.94c3.13-6.26 1.82-12.54.47-14.1a10.58 10.58 0 00-8.26-3.67c-3.31 0-6.39 1.3-7.93 3.56-.51.76-3.86 5.14-.5 14.24-.25-4.59.36-11.27 2.16-9.8 8.62 6.95 11.9 5.67 13.07 6.59 1.57 1.23.27 3.5 1 3.18M262.08 127.97s-.61 11.11-6.33 15.01c3.12 6.53 8.94 5.57 8.94 5.57s5.4-9.29 1.4-14.93l-4-5.65",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.21 127.97s.62 11.11 6.33 15.01c-3.12 6.53-8.94 5.57-8.94 5.57s-5.4-9.29-1.4-14.93l4.01-5.65",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07 115.04h-66.11a2.65 2.65 0 01-2.64-2.64V46.29a2.65 2.65 0 012.64-2.64h66.1a2.65 2.65 0 012.65 2.64v66.1a2.65 2.65 0 01-2.64 2.65",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 106.84c-2.12-18.3-6.86-30.45-17.92-30.45-10.73 0-15.59 12.15-17.81 30.45h35.73",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86 67.41c0 5.95 3.95 10.76 8.82 10.76 4.88 0 8.83-4.81 8.83-10.76 0-5.94-3.95-10.75-8.83-10.75-4.87 0-8.82 4.81-8.82 10.75",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.67 71.17c3.12-6.26 1.82-12.54.46-14.1a10.58 10.58 0 00-8.25-3.67c-3.32 0-6.4 1.3-7.94 3.56-.51.76-3.85 5.14-.5 14.24-.24-4.59-.13-9.5 2.16-9.8 9.18-1.2 12.68-.02 13.85.9 1.56 1.23-.5 9.19.22 8.87",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4 101.17h-66.11a2.65 2.65 0 01-2.64-2.64v-66.1a2.65 2.65 0 012.64-2.65h66.1a2.65 2.65 0 012.65 2.64v66.1a2.65 2.65 0 01-2.64 2.65",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.52 92.82c-2.28-18.37-7.27-30.49-18.56-30.49-10.95 0-16.04 12.12-18.43 30.5h36.99",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.96 52.96c0 6.2 4.13 11.24 9.22 11.24 5.09 0 9.21-5.03 9.21-11.24 0-6.2-4.12-11.23-9.21-11.23-5.1 0-9.22 5.03-9.22 11.23",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.6 53.42c1.45-5.83 1.12-7.32 1.12-7.32s-.3-1.24-.59-1.87c-.28-.63-5.97-4.78-9.61-4.78-3.65 0-8.45 3.46-9.08 4.28-.63.81-1.06 3.94-1.06 3.94s-1.02.95.69 6.27c-.26-5.27.03-7.3 2.38-6.26 10.98 4.81 12.63-1.32 14 .43 3.18 4.06 1.35 5.67 2.15 5.3",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.07 45.77a3.03 3.03 0 114.12-4.44 3.03 3.03 0 01-4.12 4.44M306.25 46.92a3.03 3.03 0 114.13-4.44 3.03 3.03 0 01-4.13 4.44",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77 50.94a5.13 5.13 0 117-7.51 5.13 5.13 0 01-7 7.51",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.54 48.46a5.13 5.13 0 117-7.52 5.13 5.13 0 01-7 7.52",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.26 45.77a3.03 3.03 0 114.13-4.44 3.03 3.03 0 01-4.13 4.44M295.05 44.94a4.4 4.4 0 115.98-6.43 4.4 4.4 0 01-5.98 6.43",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84 46a4.4 4.4 0 116-6.43 4.4 4.4 0 01-6 6.43",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27 199.94c.22.49.25 1.04.1 1.54l-.29 2-.34.24-1.28.53c.13-.4 0-.8 0-.8l-.57-2.08s-.87-3.49 1.5-3.34c-.01-2.85.78-2.38.78-2.38l.1 4.3",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.17 206.86s-1.66 6.33-3.07 6.44c-1.42.12-2.89-10.02-2.89-10.02l-1.92.23s-.75 14.58 3.57 14.84c4.3.27 4.88-2.95 4.88-2.95l-.57-8.54",
    fill: "#FAD473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.35 224.16h11.28v-17.14c-3.22-4.92-7.24-3.58-7.24-3.58s-3.65.07-4.22 3.42c0 2.43.18 17.3.18 17.3",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71 201.17l.17 2.42-.08.08a2.1 2.1 0 01-2.86.04l-.03-1.83 2.8-.71",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6 196.1l-.2 4.01c-.4-.02-.64.41-.56.79-.04.09-.07.19-.07.3a4.6 4.6 0 01-3.57.82c-2.53-.48-1-5.38-1-5.38l5.4-.53",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.87 199.11c.02-.3.42-.91.64-1.1 1.44-1.25.16-2.15-.3-2.45-.5-.32-.4-1.23-1.06-1.74-1-.78-1.95.03-2.59-.1-.64-.11-1.03-.96-1.96-.5-.93.44-.83 1.17-1.12 1.47-.3.31-.85-.54-1.75.43-1.38 1.48 1.32 2.1 1.32 2.1s1.48.62 3.43-.15c.27-.1.59-.04.76.19.47.64.47 3.98.47 3.98l.65-.54s1.43-.24 1.51-1.59",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35 199.44a.62.62 0 11-1.14-.47.62.62 0 011.14.47",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9 256.48s-.63.88-3.63 1.64c-.66.17-1.37.29-1.37 1.38h2.96l3.03-.53v.53h1.63s.46-2.68-.5-3.02h-2.11",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.75 254.56l.16 1.92c.6.41 1.38.44 2 .07l.11-.07v-1.92h-2.27",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.31 256.48s-.63.88-3.63 1.64c-.66.17-1.37.29-1.37 1.38h2.96l3.02-.53v.53h1.64s.45-2.68-.5-3.02h-2.12",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.16 254.56l.15 1.92c.6.41 1.38.44 2 .07l.12-.07v-1.92h-2.27",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.63 207.02s3.38 7.81-.94 11.8c-4.31 3.99-10.17 3.3-10.17 3.3v-2.24s5.3-.45 7-3.99c1.69-3.54-.69-6.6-.69-6.6",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86 221.82l-2.7.06c-1.1-.07-1.82-1.7-2-2.92a.25.25 0 01.32-.27c.92.32 3.28 1.15 3.89 1.53l.5 1.6",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.35 224.16c-3.37 9.5 1.9 30.55 1.9 30.55h3s-1.42-29.84 2.48-30.55h-7.38",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.11 213.53c-.03.74-.2 1.54-.6 2.36-1.7 3.54-7.27 4-7.27 4v2.28s6.14.64 10.45-3.35c1.57-1.45 2.12-3.4 2.19-5.3h-4.77",
    fill: "#FAD473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09 213.87l.35-.16a7.25 7.25 0 00-1.34-4.61l-.27.2c.02.03 1.54 2 1.26 4.57",
    fill: "#E98333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.75 200.24s.62-.18.72-1.32c.1-1.14.63-.79.63-.79s-.28 4.48-.99 4.65c-.71.17-.36-2.54-.36-2.54",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67 224.16c-.92 11.66 6.52 30.55 6.52 30.55h3.57s-2.43-12.08-2.47-23.42c-.02-2.45.08-4.87.34-7.13h-7.96",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33 255.98s.49.67 2.76 1.25c.5.13 1.04.21 1.04 1.04h-2.25l-2.29-.4v.4h-1.24s-.34-2.03.38-2.29h1.6",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.45 254.53l-.12 1.45a1.4 1.4 0 01-1.51.05l-.09-.05v-1.45h1.72",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84 256.27s.48.67 2.75 1.25c.5.13 1.04.21 1.04 1.04h-2.24l-2.3-.4v.4h-1.23s-.35-2.03.38-2.29h1.6",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.96 254.82l-.12 1.45a1.4 1.4 0 01-1.52.05l-.08-.05v-1.45h1.72",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.37 218.8l-.56 36.52h-2.66s-4.05-29.49-3.19-36.52c.87-7.04 6.4 0 6.4 0",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 218.79s-.92 11.22-3.05 17.43c-2.13 6.2-5.97 19.1-5.97 19.1h-2.75s4.6-26.94 3.54-36.53h8.23",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.95 200.2s3.28 7.65 4.11 7.65c.67 0-.25-6.25-.25-6.25h2.75s3.45 10.7.7 12.66c-2.74 1.96-8.77-5.53-8.77-5.53l1.46-8.53",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.17 219.76l1 2.46c.48.96 2.23.99 3.4.68a.24.24 0 00.12-.4c-.64-.7-2.31-2.5-2.89-2.9l-1.63.16",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49 198.62s1.7 1.16 1.7 2.5v17.67h-10.03v-16.53s.21-3.67 3.8-3.67c3.6 0 4.53.03 4.53.03",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M161.03 218.8v-15.88l.34.01v15.87h-.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85 194.67v4.17s.7.95 1.94.95c1.26 0 1.26-.9 1.26-.9v-2.67l-1.86-.48-1.34-1.07",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2 197.01c.4-.01.75-.07.94-.24 1.1-1.77-.16-6.55-.16-6.55l-4.03.72-.13 3.2c-.04.86.34 1.68 1 2.21.72.44 1.55.69 2.39.66",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.84 191.03s1.34.25 2.75 0 .51-1.8.51-1.8-1.04.47-2.9.2c-1.25-.19-1.58-.43-2.38 0-1.1.58-.83 2.55-.83 2.55l.6 4.16h.23s.05-2.47.05-3.32c.24-.38.5-.38.69-.29.21.1.33.34.33.58v4.32s2.76 1.19 3.46.98c.7-.22.23-3.43.23-3.43s-.8-.35-1.43.35c-.62.7-1.38-.02-1.38-.02l.07-4.28",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.03 201.6l-.1-.53c-.2-1.16-1.32-2.62-2.45-3h-1.17l.37 2.5 1.64 1.03h1.71M156.2 192.43c.32-.03.61.27.67.66.06.39-.15.73-.45.75-.31.03-.61-.27-.67-.66-.06-.4.15-.73.46-.75",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16 200.29l2.27 1.31h-1.45l-2.4-2.01s.17-.35.71-.06c.55.3.87.76.87.76",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 199.7s-5.67 6.3-5.67 10.08c0 3.77 4.6 10.43 4.6 10.43l2.28-.67s-2.05-8.23-2.05-10.43c0-2.19 4.21-5.4 4.21-5.4",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.55 209.11c0 1.9 1.67 8.79 2.07 10.4l-.34.08c-.48-1.98-2.06-8.62-2.06-10.48 0-2.24 4.1-5.4 4.28-5.53l.2.26c-.04.03-4.15 3.19-4.15 5.27",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64 196.16s-.47 2.44 1.04 4.4c.09.12.25.22.42.24.35.05.6-.08.79-.13.27-.08.4-.22.47-.34.05-.1.04-.22-.03-.33-.3-.46-1.25-2.02-.82-3.4-.8-.66-1.87-.44-1.87-.44",
    fill: "#EC944F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1 200.58c.17-.08.2-.14.26-.25.05-.1.04-.22-.03-.33-.3-.46-1.25-2.02-.82-3.4-.29-.24-.6-.36-.9-.42-.04 1.52.28 2.54 1.48 4.4",
    fill: "#F2AE53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.98 198.18c.08.34.24.6.38.58.14-.03.2-.34.12-.69-.07-.35-.24-.6-.38-.58-.14.03-.19.34-.12.69",
    fill: "#EC944F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC944F",
    d: "M164.07 197.5l.15-.03-.01.07-.1.04-.04-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC3F5E",
    d: "M164.33 198.76l.17-.04-.2-.03.03.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1 198.15c.07.35.24.61.38.58.14-.03.19-.33.12-.68-.07-.35-.24-.61-.38-.58-.14.02-.2.33-.12.68M162.02 194.1h-.26c-.52 0-.94.4-.94.9v.7c0 .5.42.9.94.9h.26v-2.5",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25 194.8c0 1.93-.45 3.5-1 3.5-.54 0-.99-1.57-.99-3.5s.45-3.5 1-3.5c.54 0 .99 1.57.99 3.5",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M168.22 193.52l.78.5v1.14l-.8.73-.28-1.47.3-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26 194.8c0-1.62.32-2.98.74-3.37a15.98 15.98 0 01-7.13 2.7v2.47s5.2-.3 7.13 1.58c-.42-.4-.74-1.75-.74-3.38",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11 194.59c0 .31-.05.57-.1.57-.07 0-.11-.26-.11-.57 0-.32.04-.57.1-.57.06 0 .11.25.11.57",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.77 199.8c-.08.02-.36.2-1.27.2-.66 0-.96-.81-1.07-1.25-.04-.16-.07-.38.12-.48l1.06-.15 1.16 1.67",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M195.69 22.97l-2.7.8-.68-2.92 4.38-.23-1 2.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07 23.64c.15.31.34.59.53.68 1.75.3 4.84-2.4 4.84-2.4l-.06-1.75-2.02-1.31-2.44 1c-.65.28-1.12.87-1.27 1.6-.05.74.08 1.5.42 2.18",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14 19.78c.45-.08 1.35-.57 1.48-.13.09.32.52 1.37.68 1.71.38.82 1.39 2.13 2.64 1.55.62-.29.88-1.14.86-1.6a1.83 1.83 0 00-.54-1.2c-.74-.75-2-1.63-2.12-2.15-.21-.88-1.06-1.46-1.74-1.13a7.53 7.53 0 00-2.17 1.93c-.3.4-.54.84-.7 1.31l1.61-.29",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66 19c.25.1.38.46.29.79-.09.33-.36.51-.6.4-.25-.1-.38-.46-.3-.8.1-.32.37-.5.61-.4",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005C5A",
    d: "M192.83 24.44l1.36 3.78-3.37 2.82v-6.6h2.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.93 41.33s1.13 1.05 3.7 1.7c.58.15 1.19-.05 1.19.89h-3.13l-2.6-.45v.45h-1.4s-.4-2.3.42-2.6h1.82",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.66 39.68l.27 1.65c-.51.35-1.18.38-1.72.05l-.1-.05.14-1.65h1.4M161.64 39.72l-1.52-.3a1.48 1.48 0 01.13-1.6l.06-.09 1.53.18-.2 1.8",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.64 31.91s1.96-.08 5.82-2.47c-2.61 4.66-1.76 11-1.76 11h2.21l5.46-14.3-13.07-.67v6.59l1.34-.15",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87 20.64s-6.82-7.06-20.34 1.88l5.8 6.92 7.04-2.38 5.34 1.48 2.16-7.9",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.37 27.06s.34 5.9 1.48 8.75c1.13 2.84 6.65 8.07 6.65 8.07l.77-1.7-3.79-6.71.23-6.93-5.34-1.48",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26 42.26c.03.16.18.7.98 1.5.71.73 2.64 1.8 1.68 2.3-1.08-.24-2.37-.39-2.37-.39-.64-.2-1.3-1.12-1.6-1.77l-.69-2.11.59-.96.44.15c.26.48.58.9.97 1.28",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23 42.83v.16a4.66 4.66 0 00-.4-.11l-1.26-1 .56-.53 3.15 1.63s-.02.45-.76.34c-.73-.11-1.3-.5-1.3-.5",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.53 22.52s-3.64 2.8-3.87 6.36c-.23 3.55 3.41 10.2 3.41 10.2s-4.07-3.4-11.47-1.45c-.46 1.95-.46 2.35-.46 2.35s15.34 5.59 17.61 2.82c2.28-2.77.57-13.36.57-13.36l-5.8-6.92",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3 39.42s-1.15.35-1.4 3.78c-.06.7-.3.53-.56.71-.23-1.05-.8-3.24-.8-3.24l.86-2.26-.49-.37.8-1.27s1.6.17 1.78.96l-.2 1.69M306.82 183.7s-1.23 1.15-4.03 1.86c-.62.16-1.28-.05-1.28.97h3.4l2.83-.5v.5h1.53s.42-2.5-.47-2.82h-1.98",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 181.91l-.18 1.8c.56.38 1.3.4 1.88.06l.1-.06.64-1.8H307",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34 183.7s-1.23 1.15-4.03 1.86c-.62.16-1.29-.05-1.29.97h3.4l2.84-.5v.5h1.52s.43-2.5-.46-2.82h-1.98",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51 181.91l-.17 1.8c.56.38 1.29.4 1.87.06l.1-.06.64-1.8h-2.44M312.44 122.9l.48 2.94 2.61-1.17-.86-3.52-2.23 1.76",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5 123.18c-.37-.01-.7-.07-.89-.21-1.05-1.53.15-5.66.15-5.66l1.68-.7 2.14 1.33.12 2.76c.03.74-.32 1.45-.95 1.9-.68.39-1.46.6-2.26.58",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.99 118.73a.92.92 0 00-1.05-.68c-.34.05-.75.1-1.15.1-.95 0-2.13-.37-2.13-1.81s1.78-.95 1.78-.95 3.64.55 5.05 1.6c.67.51-.46 2.12-.87 2.92-.24.47-.56.89-.95 1.24l-.68-2.42",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2 119.6c-.2-.18-.6-.14-.88.09s-.33.56-.12.75c.21.19.6.15.89-.08.27-.23.32-.56.11-.75",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.92 125.84s-3.93 6.45-6.28 21.43c4.74 1.49 11.97 3.1 11.97 3.1s4.27-16.24-3.08-25.7c-1.54 0-2.6 1.17-2.6 1.17",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64 147.27s-3.29 11.05-3.29 16.05 3.3 19.1 3.3 19.1h3.01s.71-9.86-.16-15.4a11.2 11.2 0 01.33-4.88c1.62-5.55 3.35-13.06 3.35-13.06l-6.54-1.8",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.9 148.15s-.86 12 .5 16.32c1.37 4.33 5.93 17.95 5.93 17.95H318s.69-7.42-1.48-15.3a9.9 9.9 0 01.2-5.8c2.08-6.13 1.89-10.95 1.89-10.95l-9.72-2.22",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.24 148.94c-.14.08-.62.32-1.7.27-.97-.05-2.97-.73-2.7.27.86.62 1.79 1.44 1.79 1.44.55.33 1.63.2 2.28 0l1.94-.86.31-1.04-.39-.22c-.5.13-1.02.17-1.53.14",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85 149.33l-.12.1.35.22c.5.07 1 .17 1.5.25l.03-.73-3.18-1.2s-.3.3.24.75c.55.45 1.18.6 1.18.6",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44 131l-.88 7.2a6.57 6.57 0 01-1.74 3.7l-6.47 6.86.64 1.6s9.75-4.59 11.54-7.3c1.8-2.73 2.7-11.03 2.7-11.03l-5.79-1.02",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71 134.8c-.42 2.66-1.18 6.51-2.28 8.18-1.65 2.5-10.24 6.67-11.37 7.21l-.56-1.4 6.41-6.8a6.66 6.66 0 001.78-3.78l.4-3.22-.25-.15-.4 3.34a6.4 6.4 0 01-1.71 3.63l-6.47 6.86-.06.06.72 1.81.13-.06c.4-.18 9.8-4.64 11.59-7.36 1.17-1.77 1.95-5.8 2.36-8.49l-.29.17",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M312.77 124.9l2.56-1.4.2 1.17-2.76 1.43v-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.2 204.11s-4.24 4.29-6.98 6.3c-2.23 1.63-6.96 3.09-8.62 3.57-.38.1-.78.07-1.13-.12l-1.56-.8s-1.92.46-1.83 1.09c.35.62.71 1.09 1 1.41.36.39.87.57 1.4.5 2.09-.25 8.14-1.12 12.2-2.83 4.98-2.1 10.03-6.29 10.03-6.29l-4.5-2.83",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB4B5",
    d: "M27.65 259.12l31.83-98.94h-1.82l-31.82 98.94h1.81M44.1 259.12l31.83-98.94h-1.81L42.3 259.12h1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB4B5",
    d: "M49.42 185.87v1.48l17.05-.01.3-1.48-17.35.01M52.95 176.29v1.47H70l.29-1.48H52.95M55.86 166.7v1.48l17.05-.01.3-1.48-17.35.01M46.31 195.58v1.48l17.06-.01.29-1.48-17.35.01M43.4 205.3v1.47l17.05-.01.3-1.48-17.35.01M40.38 215.38l-.68 1.48 17.05-.01.29-1.48-16.66.01M37.19 225.47l-.7 1.47h17.06l.3-1.48H37.18M34.2 235.33l-.7 1.48 17.06-.01.29-1.48-16.66.01M31.71 245.4l-.69 1.48h17.06l.29-1.48H31.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M106.98 259.12l-31.83-98.94h1.81l31.83 98.94h-1.81M90.52 259.12L58.7 160.18h1.8l31.83 98.94h-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13374D",
    d: "M85.21 185.87v1.48l-17.05-.01-.3-1.48 17.35.01M81.68 176.29v1.47H64.63l-.29-1.48h17.34M78.77 166.7v1.48l-17.05-.01-.3-1.48 17.35.01M88.32 195.58v1.48l-17.06-.01-.29-1.48 17.35.01M91.23 205.3v1.47l-17.05-.01-.3-1.48 17.35.01M94.25 215.38l.68 1.48-17.05-.01-.29-1.48 16.66.01M97.44 225.47l.7 1.47H81.07l-.3-1.48h16.66M100.44 235.33l.69 1.48-17.06-.01-.29-1.48 16.66.01M102.92 245.4l.69 1.48H86.55l-.29-1.48h16.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 163.3l1.3.22c.26-1.6 4.27-9.17 4.6-13.1a88.87 88.87 0 011.37-9.24l-4.3-1.28s-1.1 0 .1 8.9c-2.7 3.54-3.42 11.57-3.06 14.5",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.58 136.67s1.01 6.08 2.42 12.6c-1.47 3.93.77 14.9.81 14.86.17-.16.94.8.94.8s1.64-9.69 2-14.05c.36-4.37.45-9.7.45-9.7l-6.62-4.51",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63 163.52s-.62.52-.5 1.18c.11.67.27 2.22.27 2.22h.63l-.02-1.45c0-.1 1.35 1.45 1.58 1.45h3.34s.22-.98-1.74-1.3c-1.96-.3-3.56-2.1-3.56-2.1",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84 162.42l-.09 1.38c-.02.29.06.58.23.82.18.26.5.62 1 1.04-.96.31-1.84-.78-2.3-1.5a1.72 1.72 0 01-.25-1.18l.16-1.09 1.25.53",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 163.18s-.84.07-.99.72c-.14.65-.54 1.96-.54 1.96l.47.37.65-1.3s1.4 1.9 1.63 1.99h3.64s0-1.2-2.28-1.26c-2.1-.05-2.57-2.48-2.57-2.48",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M78.9 98.77l-4.04 10.57-2.55-1.9 5.7-9.6.9.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4 95.57c-.25.32-.38.71-.36 1.12l-.18 1.52.2.24.72.63c-.02-.31-.06 0-.06 0l1.15-2s1.4-.9-.36-2.2c-.17-.13-.4-.16-.58-.04-.43.29-.53.73-.53.73",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M66.67 111.93h-2.6l1.03-3.07 2.04 1.26-.47 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.13 115.22l-.04-.2a89.45 89.45 0 014.77-5.68l-2.2-2.5-4.98 4.74H66.2s-1.97-1.3-3.7.48c-.63.65-1.05 2.41-.63 4.28 1.16 5.14.26 7.86.26 7.86l6.72 2.5.26-7.6v-.01c.02-.61.22-1.2.55-1.72.37-.6.6-1.33.46-2.15",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.59 103.36l-4.28 1.5.42 3.19.03.13.24.05.04.01h.04a2.93 2.93 0 012 2c.6.11 1.24.11 1.85-.02.42-.08.8-.21.97-.41.9-1.97-1.31-6.45-1.31-6.45",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.49 106.07c-1.15.57-.88 6.5-1.08 10.54a4.6 4.6 0 01-3.89 4.29c-1.52.24-3.2.29-4.2-.29.66-.54 4.26-5.83 3.1-12.84-.14-.92-.16-3.49 1.4-4.88 1.72-1.55 5.28.47 5.28.47s.97 1.94-.61 2.71M69 124.04s.9 4.56.9 7.27c0 1.49-.37 10.87-.37 10.87s-6.4.47-7.63.47c-.31-7.7-2.06-7.93-2.06-11.52 0-1.56.8-3.32 1.4-4.44.45-.8.73-1.37.9-2.5l.04-.14H69",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M343.78 66.78l.94 2.09 2.76-1.3-2.38-3.42-1.32 2.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.44 61.48s.61 5.4 1.84 5.92c1.23.52 2.68-1.3 2.68-1.3l1.38-3.2-4.38-1.89-1.52.47",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.45 60.41s.94 1.87 3.64 1.03c.77.02 1.18.79 1.4 1.47.24.79.33.18.96.72l1.1 1.58s2.53-4.75-.88-6.18c-3.42-1.44-6.22 1.38-6.22 1.38",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25 62.81c-.26-.07-.58.13-.72.44-.14.32-.04.63.22.7.26.07.58-.13.72-.45.14-.31.04-.62-.22-.69",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59 67.35c6.8 4.03 4.2 20.68 4.2 20.68h-10.34l-.26-8.95c-.1-3.48-.43-7.1.5-9.09 1.3-2.73 4.2-3.64 5.9-2.64",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.03 78.14s-1.54 5.35-3.61 7.13c-2.08 1.78-8.04 6.57-8.04 6.57l-1.95-.41 6.55-7.91 2.37-7.7 4.68 2.32",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M345.54 78.65l-5.7-2.32L342.7 70l3.75 1.95-.91 6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07 124.28s-1.14 1.06-3.75 1.72c-.58.15-1.2-.05-1.2.9h3.17l2.63-.46v.46h1.43s.4-2.33-.44-2.62h-1.84",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.35 122.6l-.28 1.68c.52.36 1.2.38 1.74.05l.1-.05-.14-1.68h-1.42",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.8 88.03s1.01 3.49 1.22 11.99c.04 1.72.5 3.4 1.25 4.94 2.98 6.16 1.63 18.06 1.63 18.06h-2.05l-8.21-29.24 2.89-5.75h3.27M343.9 125.28s-1.14 1.06-3.75 1.73c-.58.14-1.2-.05-1.2.9h3.17l2.63-.46v.46h1.43s.4-2.33-.44-2.63h-1.84",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.18 123.61l-.28 1.67c.52.36 1.2.38 1.74.06l.1-.06-.14-1.67h-1.42M333.38 91.84l-1.55 2.3c-.7.88-2.5.52-3.63-.05a.25.25 0 01-.03-.44c.8-.57 2.9-2.05 3.58-2.34l1.63.53",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.45 88.03l1.02 36.08h2.16s3.05-10.03 2.38-16.95a11.2 11.2 0 01.82-5.52c3.22-7.45 2.7-13.6 2.7-13.6h-9.08",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M339.35 102.26h-3.65l-.1 28.15h3.87l-.12-28.15M364.18 102.26h-3.65l-.1 28.15h3.87l-.12-28.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M333.66 102.9l32.16.01v-1.62l-32.16.1v1.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M348.97 101.35v28.24h1.54l-.09-28.24h-1.45M404.36 102.91h3.67v-3.67h-3.67zM438.97 239.73h-65.14a4.54 4.54 0 01-4.53-4.53c0-2.5 2.04-4.53 4.53-4.53h65.14c2.49 0 4.52 2.04 4.52 4.53s-2.03 4.53-4.52 4.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64 246.45a11.17 11.17 0 11-22.34 0 11.17 11.17 0 0122.34 0",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.37 246.45a7.9 7.9 0 11-15.8 0 7.9 7.9 0 0115.8 0",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.26 246.45a11.17 11.17 0 11-22.34 0 11.17 11.17 0 0122.34 0",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.99 246.45a7.9 7.9 0 11-15.8 0 7.9 7.9 0 0115.8 0",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.42 232.04h-23.1c-5.07 0-9.23-.56-9.23-5v-10.12c0-8.5 7.96-16.06 17.7-16.06h6.17c9.73 0 17.68 7.57 17.68 16.06v10.13c0 4.43-4.15 4.99-9.22 4.99",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M399.82 201.51h12.98v-3.3h-12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M399.46 152.73l.36 45.48h4.85l-.02-45.48h-5.2M410.62 152.73l.16 45.48h2.02l-.02-45.48h-2.16M435.79 126.53l-23.35 26.2h-4.85l23-26.2h5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M424.63 126.53l-23.15 26.2h-2.02l23-26.2h2.17M399.46 100.32l23.35 26.2h4.85l-23-26.2h-5.2M410.62 100.32l23.15 26.2h2.02l-23-26.2h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M412.64 100.32l-35.83 26.2h-4.84l35.48-26.2h5.2M401.48 100.32l-35.63 26.2h-2.01l35.48-26.2h2.16M399.46 152.73h13.46l-6.76-7.69-6.7 7.7M422.46 126.53h13.33l-6.3-7.18-7.03 7.18M399.46 100.32h13.18l-6.4-7.14-6.78 7.14M335.6 126.66v3.64l40.98.1v-3.87l-40.98.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M28.21 198L27 200.75l-1.99-1.8 1.4-3.97 1.81 3.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92 198.18c.34.05.65.04.84-.08 1.2-1.37.8-5.4.8-5.4l-1.42-1.22-2.17 1.01-.56 2.22c-.15.73.05 2.01.55 2.57.56.48 1.23.8 1.96.9M29.25 212.65s.49.71 1.46 1.05c.98.33 8.26-1.2 8.26-1.2l1.47.16c.76.2 1.57.16 2.31-.12l2.15-.83-12.57-.26-4.8-5.97 1.72 7.17",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 198.95s-2.9 3.71-3.58 6.16c-.68 2.44-.92 9.18-.92 9.18h6.11s1.75-3.18 3.12-6.06c.4-.87.42-1.87.03-2.74-1-2.26-2.5-5.37-2.5-5.37L25 198.95",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 254.97l.49 1.26c.12.35.35.64.66.84.34.22.87.52 1.67.76-.97.83-2.52-.04-3.4-.65-.43-.3-.74-.75-.87-1.25l-.2-.96h1.66",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.56 255.63s-.66.51-.54 1.17c.12.66.3 2.2.3 2.2h.67l-.02-1.44c0-.09 1.44 1.44 1.69 1.44h3.57s.24-.97-1.86-1.28c-2.1-.31-3.81-2.1-3.81-2.1",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.16 254.97l.48 1.26c.12.35.36.64.66.84.34.22.88.52 1.67.76-.97.83-2.51-.04-3.4-.65-.43-.3-.73-.75-.86-1.25l-.2-.96h1.65",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.61 255.63s-.66.51-.54 1.17c.12.66.3 2.2.3 2.2h.67l-.02-1.44c0-.09 1.45 1.44 1.7 1.44h3.57s.23-.97-1.86-1.28c-2.1-.31-3.82-2.1-3.82-2.1",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.61 214.4s3.03 4.54.44 22.66c.4 6.84 1.16 18.11 1.16 18.11H26.5s-4.77-12-3.17-17.98c.38-5.92-1.08-22.9-1.08-22.9l4.37.11",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 214.3s-3.17 2.55-3.17 6.34c0 2.97 1.43 9.13 2.25 13.16.3 1.46 0 2.97-.41 4.4-1.68 5.86.36 16.97.36 16.97h1.71s.1-5.72 2.43-18.53c2.7-14.73 2.94-22.35 2.94-22.35h-6.1",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M45.24 211.71h-9.98v-.73h9.54l4.23-8.06.65.34-4.44 8.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.24 205.76s3.18 7.42 4.72 7.42c1.53 0 10.01-3.63 10.01-3.63l-.22-1.26-8.66 1.46s-.77-2.04-1.3-4.39a2.42 2.42 0 00-1.87-1.86c-2.05-.39-2.68 2.26-2.68 2.26",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.47 193.98s.94.57 3.84-1.28c.44.12-.27-4.05-4.01-2.83-2.62.86-2.5 3.4-2.38 4.8.14 1.51-.65 2.51-1.7 3.62-.87.93-.86 2.64-1.44 3.57-.72 1.13-1.48 1.06-2.04 2.21-.6 1.2-.68 2.67.12 3.75.45.62 1.5 2.1 3.17 1.57.94-.3 1.2-1.93 1.24-3.31a4.18 4.18 0 011.59-3.14c.9-.71 1.88-1.7 2.15-2.72.51-2.01-.54-6.24-.54-6.24",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.13 194.06c.22-.15.58-.06.79.22.21.27.2.61-.02.77-.22.15-.57.06-.79-.21-.21-.28-.2-.62.02-.78M41.49 208.94a.42.42 0 00-.25-.43l-1.63-.7c-.4-.18-.85-.2-1.27-.07l-1.61.54h-.22l-.18 1.51.52-.2 1.02-.36s2.23 1.89 3.02.17c.24 1.7.73 1.51.73 1.51l-.13-1.97",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.03 192.52c.32 1.16 1.97 1.72 3.69 1.25 1.71-.48 2.64-1.76 2.52-2.96-.16-1.58-1.97-1.72-3.68-1.25-1.72.48-2.85 1.8-2.53 2.96",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.71 234.47c1.53 10.91-.14 22.21-.14 22.12 0-.1-1.22 0-1.22 0s-1.68-13.27-2.08-17.7c-.4-4.42 0-4.71 0-4.71s1.92-10.62 3.44.3",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M393.11 206.32l3.73 2.38 1.58-3.28-4.82-5.52-.49 6.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D29577",
    d: "M373.43 184.48l4.56 11.93 2.92-2.17-6.52-10.98-.96 1.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.16 180.43c.36.29.6.7.67 1.16l.56 1.67-.18.3-.78.92a1.2 1.2 0 00-.32-.63l-1.24-1.39s-2.04-2.37-.13-3.18c-1.12-2.2-.32-2.15-.32-2.15l1.74 3.3",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.08 180.17s.41-.4.05-1.31c-.37-.92.18-.86.18-.86s1.53 3.6 1.04 4c-.5.4-1.27-1.83-1.27-1.83",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52 198.86l-1.37.11-4.65-5.42-2.5 2.86s2.3 4.35 5.66 8.85c.2.91 1.2 10.12 1.2 10.12h8.05s-1.28-6.76.98-10.52c2.27-3.76-7.37-6-7.37-6",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16 234.47c1.52 10.91-.15 22.21-.15 22.12 0-.1-1.21 0-1.21 0s-1.69-13.27-2.09-17.7c-.39-4.42 0-4.71 0-4.71s1.92-10.62 3.45.3M386.22 190.44l4.64 1.62-.45 3.47-.03.14-.27.06h-.04l-.05.02a3.18 3.18 0 00-2.16 2.17 5.5 5.5 0 01-2.01-.03c-.46-.09-.87-.23-1.06-.45-.98-2.14 1.43-7 1.43-7",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1 193.36c.42.83.5 1.82.1 2.66a4.48 4.48 0 00-.16 3.66 4.88 4.88 0 001.7 1.53c.7.44 1.16 1.17 1.23 1.99.1 1.13.22 2.51 1.18 2.84 2.8.97 3.83.87 4.2-1.46.1-.6.06-1.47-.24-2.29-.37-.99-.34-2.1.09-3.06.28-.64.53-1.35.53-1.83 0-.53-.49-1.27-1-1.91-.63-.8-.91-1.8-.82-2.81.09-1.01-.05-2.3-1.08-3.18-1.91-1.63-6.16.94-6.16.94s-.4 1.24.43 2.92",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.42 205.42l1.79 1.86c1.19 1.23 1.56 2.94.13 3.89l-5.86 4.65.54 1c.45.85.37 1.89-.21 2.65l-.62.81-1.37-4.7 4.24-5.3c.46-.47.35-1.25-.22-1.58l1.58-3.28",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.85 215.38s-1.18 3.06-1.18 6.16c0 1.7 1.48 14.55 1.48 14.55h7.67c-.52-9.48 2.36-10.65 2.36-14.75 0-2.9-2.27-5.96-2.27-5.96h-8.06",
    fill: "#2EB4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.57 255.16s.67.53.55 1.2c-.13.67-.3 2.24-.3 2.24h-.69l.02-1.46c0-.1-1.48 1.46-1.73 1.46h-3.65s-.24-.99 1.9-1.3c2.15-.32 3.9-2.14 3.9-2.14",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.67 255.16s.67.53.55 1.2c-.12.67-.3 2.24-.3 2.24h-.69l.02-1.46c0-.1-1.47 1.46-1.73 1.46h-3.64s-.25-.99 1.9-1.3c2.14-.32 3.9-2.14 3.9-2.14",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M5.25 129.26L3 133.66l4.7-1.07 16.05-5.06-18.51 1.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BBDB7",
    d: "M3.01 133.66l7.98-.5-1.96-.99-6.02 1.49"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.68 124.48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#f)",
    d: "M1.57 4.78L.17.5l19.91 2.55L1.57 4.78"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.36 126.93)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#h)",
    d: "M16.4.6L.36 5.65l2.4 6.18L16.4.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.77 138.08a.37.37 0 01-.08-.62c.5-.42 1.03-.8 1.59-1.13.17-.1.4-.05.5.13.11.18.05.41-.12.52-.52.3-1.01.65-1.47 1.05a.37.37 0 01-.42.05M14.28 148a.38.38 0 01.02-.68 6.05 6.05 0 013.95-.37.38.38 0 01-.18.73 5.37 5.37 0 00-3.46.32.38.38 0 01-.33 0zm6.52 4.26a.37.37 0 01-.2-.43c.23-.9.15-1.72-.23-2.46-.14-.26-.31-.5-.52-.7a.37.37 0 11.54-.53c.25.26.47.56.64.88.47.9.57 1.93.3 3a.37.37 0 01-.53.24zm-19.33-9.18a.38.38 0 01-.19-.45 12.67 12.67 0 011.82-3.44c.12-.17.36-.2.52-.08.17.13.2.36.08.53a11.48 11.48 0 00-1.7 3.23.37.37 0 01-.53.21zm8.56 9.12a.38.38 0 01-.15-.54c.85-1.3 1.62-2.26 2.45-3 .15-.15.39-.13.53.02s.12.39-.03.53c-.77.7-1.51 1.6-2.32 2.86a.37.37 0 01-.48.13zm6.93 4.51a.38.38 0 010-.67 7.27 7.27 0 002.73-2.3.38.38 0 01.6.44 8 8 0 01-3 2.53.37.37 0 01-.33 0zm-16-7.65a.37.37 0 01-.2-.27 12.15 12.15 0 01-.03-3.9.37.37 0 01.74.12c-.18 1.24-.17 2.47.03 3.65a.37.37 0 01-.53.4zm10.11 8.75a.38.38 0 01.2-.71c1.26.1 2.48 0 3.64-.29a.37.37 0 11.19.73 11.7 11.7 0 01-3.89.3.37.37 0 01-.14-.03zm-7.41-3.42a10.32 10.32 0 01-2.25-3.34.37.37 0 11.7-.28 9.63 9.63 0 001.99 3.02.37.37 0 01-.44.6zm3.39 3.09a.38.38 0 01-.17-.5l.13-.25c-.57-.26-1.13-.57-1.64-.92a.38.38 0 01.42-.62c.49.33 1.01.62 1.56.87.4-.77.84-1.57 1.35-2.44a.38.38 0 01.64.38 61 61 0 00-1.3 2.35c.35.14.7.26 1.07.36.2.05.32.26.26.46a.38.38 0 01-.46.26c-.41-.12-.82-.25-1.21-.4l-.14.28a.38.38 0 01-.5.17h-.01zm-2.18 5.64a.38.38 0 01-.2-.43c.32-1.16.74-2.38 1.26-3.62.08-.2.3-.29.5-.2.18.07.27.3.2.49-.52 1.2-.93 2.4-1.23 3.53a.37.37 0 01-.53.23zm-.64 6a.37.37 0 01-.2-.3l-.02-.18c-.06-1.2 0-2.43.2-3.68a.37.37 0 11.74.1c-.19 1.2-.25 2.4-.19 3.53l.01.17a.38.38 0 01-.54.36zm1.75 5.76a.37.37 0 01-.16-.15 14.13 14.13 0 01-1.43-3.6.38.38 0 01.73-.19c.3 1.2.75 2.35 1.36 3.42.1.18.04.4-.14.5a.37.37 0 01-.36.02zm4.14 4.34l-.02-.01a11.3 11.3 0 01-2.95-2.56.37.37 0 11.58-.47c.81.98 1.74 1.78 2.75 2.38a.37.37 0 01-.36.66zM12.23 180.13a.38.38 0 01.28-.7c.57.17 1.16.27 1.76.3.2.02.36.2.35.4a.38.38 0 01-.4.35 8.85 8.85 0 01-1.99-.35",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.86 57.64)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#j)",
    d: "M.26 9.1l12.98-7.17L19.87.61l5 .73L.27 9.1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M365.12 66.74l24.3-6.25.31-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BBDB7",
    d: "M390.12 64.66l-.03.05-1.02 3.78-23.9-1.75 24.95-2.08"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.86 59.48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#l)",
    d: "M29.9 2.97L26.44.15.42 7.22l22.4-.67 7.08-3.58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.44 110.62c-.79-.28-1.58-.63-2.33-1.02a.35.35 0 00-.48.15.35.35 0 00.15.48 18.9 18.9 0 003.33 1.35.35.35 0 10.2-.68l-.87-.28M401.87 59.82c-1.1.14-2.25.32-3.51.55a.35.35 0 00.13.7 63 63 0 013.47-.55c.06 0 .11-.03.16-.07a.35.35 0 00-.25-.63M407.76 60.09a.35.35 0 00-.21-.64c-1.13 0-2.33.04-3.56.14a.35.35 0 10.06.7c1.2-.1 2.38-.14 3.5-.13.07 0 .15-.03.2-.07M442.63 106.36a.35.35 0 00-.5 0 .35.35 0 000 .5c.86.84 1.8 1.6 2.8 2.27a.35.35 0 00.48-.1.35.35 0 00-.1-.49 19.04 19.04 0 01-2.68-2.18M441.17 105.32a.35.35 0 00.05-.5 19.46 19.46 0 01-1.94-2.86.35.35 0 10-.62.34 18.98 18.98 0 002.02 2.97c.12.15.33.18.48.06h.01M438.2 100.54a.35.35 0 00.2-.46c-.43-1.02-.78-2.1-1.08-3.3a.35.35 0 10-.69.17c.32 1.24.68 2.35 1.11 3.4.07.18.28.27.46.2M428.84 70.4a28.8 28.8 0 012.03 2.83c.1.17.32.22.49.12l.02-.02c.15-.1.19-.31.1-.47a27.65 27.65 0 00-2.1-2.9c-.12-.15-.33-.2-.5-.05a.35.35 0 00-.04.5M431.91 75.05c.54 1.03 1.02 2.1 1.4 3.18a.35.35 0 10.67-.23c-.4-1.12-.88-2.22-1.44-3.28a.35.35 0 10-.63.33M424.9 66.47c.9.74 1.75 1.53 2.55 2.37.12.13.32.14.46.04.02 0 .03-.02.04-.03a.35.35 0 00.01-.5c-.82-.85-1.7-1.67-2.62-2.43a.35.35 0 00-.45.55M418.38 62.45a.35.35 0 00.47-.18.35.35 0 00-.18-.47c-1.1-.48-2.23-.9-3.36-1.23a.35.35 0 10-.2.68c1.1.32 2.2.73 3.27 1.2M435.78 89.54a.35.35 0 00.31-.39l-.05-.44c-.11-1.02-.23-2.05-.37-3.07a.35.35 0 00-.7.1c.14 1 .25 2.03.37 3.05l.05.44c.02.2.2.34.4.31M423.23 65.2a.35.35 0 00.4-.58c-.97-.68-2-1.32-3.04-1.87a.35.35 0 10-.33.62c1.02.54 2.02 1.16 2.97 1.83M435.95 90.95c-.2.02-.33.2-.3.4.17 1.37.34 2.48.53 3.5a.35.35 0 00.7-.12c-.2-1.01-.37-2.11-.54-3.48a.35.35 0 00-.4-.3M452.34 111.4a.35.35 0 00-.14.69c1.1.22 2.26.37 3.54.46a.35.35 0 00.38-.33.35.35 0 00-.33-.38 28.1 28.1 0 01-3.45-.44M434.19 79.8a.35.35 0 00-.25.43c.27 1.04.51 2.16.72 3.42a.35.35 0 00.7-.12 36.75 36.75 0 00-.74-3.48.35.35 0 00-.43-.25M410.93 59.66c-.41-.05-.83-.09-1.24-.12a.35.35 0 00-.05.7 27.68 27.68 0 013.44.5c.1.01.21-.01.29-.07a.35.35 0 00-.14-.63c-.76-.16-1.54-.29-2.3-.38",
    fill: "#5BBDB7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAddUser);
export default __webpack_public_path__ + "static/media/card-add-user.9391ceda4776db5505521baf17c7a05e.svg";
export { ForwardRef as ReactComponent };